import React,{ Component } from 'react';
import { Card, CardBody, Col, Container, Row,Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import AnimatedLineFormWithLabels from './components/AnimatedLineFormWithLabels';
import showResults from '../Show';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment'; 
import Datatable from 'react-bs-datatable';
import { MDBDataTable } from 'mdbreact';
import * as myConstClass from '../../../constant.js';
import 'font-awesome/css/font-awesome.min.css';
class Admin_list extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: []
    }
    this.flag = 0;
    this.header = [
      { title: 'Sr. No.', prop: 'id', filterable: true },
      { title: 'First Name', prop: 'first_name', filterable: true },
      { title: 'Last Name', prop: 'last_name', filterable: true },
      { title: 'Email', prop: 'email' },
      { title: 'Mobile No.', prop: 'mobile_no'},
      { title: 'Gender', prop: 'gender'},
      { title: 'User Status', prop: 'status'},
      { title: 'Action', prop: 'action',cell: (row)=><div><i id={row.id} className="fa fa-edit ptr_css" onClick={() =>this.edit(row.id)}></i>&nbsp;&nbsp;</div> },
      ];

    this.customLabels = {
      first: '<<',
      last: '>>',
      prev: '<',
      next: '>',
      show: 'Display',
      entries: 'rows',
      noResults: 'There is no data to be displayed',
    };
    
  }
  edit(e) { 
     this.props.history.push('/forms/admin_edit/'+e);
    }



  remove(e) { 
    this.flag = 1;
    fetch(myConstClass.BASE_URL+`user/deleteAdmin`, {
    method: 'POST',
    body: e,
  }).then(toast('Admin Deleted Successfully..!', {containerId: 'B',type: toast.TYPE.SUCCESS}),

  fetch(myConstClass.BASE_URL+'user/getAdmin')
  .then(response => response.json())
  .then(response =>{
    let i=1;
    response.rows.forEach(element => {
    element.action = <div><i id={element.uid} className="fa fa-edit ptr_css" onClick={() =>this.edit(element.uid)}></i></div>;
     // console.log(element);
     //element.uid=i;
     i++;
    });
    this.setState({posts: response})
  })
  .catch(err => console.log(err))
  )
  .catch();

  
  }



  onSortFunction = {
    date(columnValue) {
      // Convert the string date format to UTC timestamp
      // So the table could sort it by number instead of by string
      return moment(columnValue, 'Do MMMM YYYY').valueOf();
    },
  };

  componentDidMount() {
    fetch(myConstClass.BASE_URL+'/user/getAdmin')
    .then(response => response.json())
    .then(response =>{
      let i=1;
      response.rows.forEach(element => {
      element.action = <div><i id={element.uid} className="fa fa-remove ptr_css" onClick={() =>this.remove(element.uid)}></i><i id={element.uid} className="fa fa-edit ptr_css" onClick={() =>this.edit(element.uid)}></i></div>;
      // element.action = <div><i id={element.uid} className="fa fa-edit ptr_css"></i></div>;
       
      // console.log(element);
       //element.uid=i;
       i++;
      });
      this.setState({posts: response})
    })
    .catch(err => console.log(err))
        
  }

render() {
  
  return (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">All HR Admins
      </h3>
      </Col>
      <ToastContainer enableMultiContainer containerId={'A'} position={toast.POSITION.BOTTOM_LEFT} />
      <ToastContainer enableMultiContainer containerId={'B'} position={toast.POSITION.TOP_RIGHT} />
         
    </Row>
    <Row>
    <Col md={12} lg={12}>
    <Card>
      <CardBody>
      
    {/* <Datatable
  tableHeader={this.header}
  tableBody={this.state.posts}
  keyName="userTable"
  tableClass="striped hover responsive"
  rowsPerPage={10}
  rowsPerPageOption={[5, 10, 15, 20]}
  initialSort={{prop: "`title`", isAscending: true}}
  onSort={this.onSortFunction}
  labels={this.customLabels}
  
/> */}

    <MDBDataTable
      striped
      hover
      data={this.state.posts}
    />
      </CardBody>
      </Card>
      </Col>
    </Row>
  </Container>)
}
}



export default withTranslation('common')(Admin_list);
